import { lazy } from "react";

const Dashboard = lazy(() => import("../components/partner/dashboard/Index"));
const Referrals = lazy(() => import("../components/partner/referrals/Index"));
const Profile = lazy(() => import("../components/partner/Profile"));
import { MODULE } from '../constants/user-management.constant';


const PartnerRoutes = [
    { path: '/dashboard/:tab?', id: 'PARTNER_DASHBOARD', moduleIds: [MODULE.PARTNER_DASHBOARD], element: <Dashboard />, base: '/dashboard' },
    { path: '/referrals/:id?', id: 'PARTNER_REFERRALS', moduleIds: [MODULE.MANAGE_REFERRAL_CLIENT], element: <Referrals />, base: '/referrals' },
    { path: '/profile', id: 'PARTNER_PROFILE', moduleIds: [MODULE.VIEW_PARTNER_PROFILE], element: <Profile />, base: '/profile' },
]

export default PartnerRoutes;